import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { capitalizeFirstLetter } from '../../../../utils/textFormatUtils';
import EmptyState from '../../../../components/EmptyState';

const BasicDrugInfo = forwardRef(function (
  { basicDrugInfo, patientEducation },
  ref,
) {
  let drugDescription;
  patientEducation?.Sections?.forEach((section) => {
    if (section.Title === 'Uses') {
      drugDescription = section.Text;
    }
  });

  return (
    <div ref={ref} className="mb-36 scroll-offset" id="general-info-section">
      <h4 className="mb-3">General Information</h4>
      <div>
        <div className="accordion-body">
          <div>
            <div className="drugsearch-content">
              <h3>Description</h3>
              {drugDescription ? (
                <p>{drugDescription}</p>
              ) : (
                <EmptyState message="Drug description not available from source" />
              )}
            </div>
            <div className="row mb-3">
              <div className="col-sm-6 col-12 drug-info">
                <label>Drug Type</label>
                {basicDrugInfo.NameTypeCodeDesc ? (
                  <p>{basicDrugInfo.NameTypeCodeDesc}</p>
                ) : (
                  <EmptyState message="Drug type not provided by manufacturer" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info">
                <label>Generic Name</label>
                {basicDrugInfo.DispensableGenericDesc ? (
                  <p>
                    {capitalizeFirstLetter(
                      basicDrugInfo.DispensableGenericDesc,
                    )}
                  </p>
                ) : (
                  <EmptyState message="Generic name not provided by manufacturer" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info">
                <label>Classification</label>
                {basicDrugInfo.DefaultETCDesc ? (
                  <p>{basicDrugInfo.DefaultETCDesc}</p>
                ) : (
                  <EmptyState message="Classification not listed in source data" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info text-capitalize">
                <label>Route</label>
                {basicDrugInfo.RouteDesc ? (
                  <p>{basicDrugInfo.RouteDesc}</p>
                ) : (
                  <EmptyState message="Administration route not documented" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info text-capitalize">
                <label>Dosage Form</label>
                {basicDrugInfo.DoseFormDesc ? (
                  <p>{basicDrugInfo.DoseFormDesc}</p>
                ) : (
                  <EmptyState message="Dosage form not provided by manufacturer" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info">
                <label>Strength</label>
                {basicDrugInfo.MedStrength ? (
                  <p>
                    {basicDrugInfo.MedStrength} {basicDrugInfo.MedStrengthUnit}
                  </p>
                ) : (
                  <EmptyState message="Strength information not provided" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info text-capitalize">
                <label>Status</label>
                {basicDrugInfo.StatusCodeDesc ? (
                  <p>{basicDrugInfo.StatusCodeDesc}</p>
                ) : (
                  <EmptyState message="Marketing status not available in database" />
                )}
              </div>
              <div className="col-sm-6 col-12 drug-info">
                <label>Federal Legend</label>
                {basicDrugInfo.FederalLegendCodeDesc ? (
                  <p>{basicDrugInfo.FederalLegendCodeDesc}</p>
                ) : (
                  <EmptyState message="Federal legend status not documented" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

BasicDrugInfo.propTypes = {
  basicDrugInfo: PropTypes.object.isRequired,
  patientEducation: PropTypes.object.isRequired,
};

BasicDrugInfo.displayName = 'BasicDrugInfo';

export default BasicDrugInfo;
